var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5621 2.53451C14.8843 1.66389 16.1157 1.66389 16.4379 2.53451L19.5268 10.8824C19.6281 11.1561 19.8439 11.3719 20.1176 11.4732L28.4655 14.5621C29.3361 14.8843 29.3361 16.1157 28.4655 16.4379L20.1176 19.5268C19.8439 19.6281 19.6281 19.8439 19.5268 20.1176L16.4379 28.4655C16.1157 29.3361 14.8843 29.3361 14.5621 28.4655L11.4732 20.1176C11.3719 19.8439 11.1561 19.6281 10.8824 19.5268L2.53451 16.4379C1.66389 16.1157 1.66389 14.8843 2.53451 14.5621L10.8824 11.4732C11.1561 11.3719 11.3719 11.1561 11.4732 10.8824L14.5621 2.53451Z",
    fill: "#60D5F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_18322_27422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5621 7.53451C14.8843 6.66389 16.1157 6.66389 16.4379 7.53451L18.1764 12.2328C18.2777 12.5065 18.4935 12.7223 18.7672 12.8236L23.4655 14.5621C24.3361 14.8843 24.3361 16.1157 23.4655 16.4379L18.7672 18.1764C18.4935 18.2777 18.2777 18.4935 18.1764 18.7672L16.4379 23.4655C16.1157 24.3361 14.8843 24.3361 14.5621 23.4655L12.8236 18.7672C12.7223 18.4935 12.5065 18.2777 12.2328 18.1764L7.53451 16.4379C6.66389 16.1157 6.66389 14.8843 7.53451 14.5621L12.2328 12.8236C12.5065 12.7223 12.7223 12.5065 12.8236 12.2328L14.5621 7.53451Z",
    fill: "#178FC2",
    fillOpacity: 0.72
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18322_27422",
    x: 6.88159,
    y: 6.88153,
    width: 17.2368,
    height: 17.7115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.474576,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_18322_27422"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.474576
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18322_27422"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star-2.4b90bd0e44f8898db5995934464374ce.svg";
export { ForwardRef as ReactComponent };